module.exports = {"id":"177326","name":"Mathieu Valbuena","rating":"81","photo":"./data/images/photos/1/177326.png","club":{"name":"Fenerbahçe","logo":"./data/images/clubs/Fenerbahce.png"},"positions":["AG","MG","MOC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MathieuValbuena0.json
// module id = 2871
// module chunks = 0